import Btn from '@components/Btn';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useI18n } from '@lib/i18n';

import { HP_ANIMATIONS, HP_ANIMATION_TYPE } from '@lib/constants';
import { staggerAnimations } from '@lib/helpers';
import { initTriggeredAnimations } from '@lib/helpers/blockAnimations';

export default function ProspectusButton({ classes = []}) {
	const router = useRouter();

	const { t } = useI18n();

	const { prospectusId, authenticated } = useSelector((state) => state.user);

	const [redirect, setRedirect] = useState('/overview');

	useEffect(() => {
		if (authenticated && prospectusId) {
			setRedirect('/prospectus/' + prospectusId);
		}
	}, [prospectusId]);

	useEffect(() => {
		staggerAnimations();
		initTriggeredAnimations();
	}, []);

	const handleClick = () => {
		router.push(redirect);
	};

	if (!prospectusId) {
		return;
	}

	const animationClass = HP_ANIMATIONS && HP_ANIMATION_TYPE
	? `animate ${HP_ANIMATION_TYPE} hp-has-triggered-animation`
	: '';

	const mergedClasses = [
		'outline',
		'mb-0',
		'outline--home',
		animationClass,
		...(classes || [])
	];

	const animationData =
	HP_ANIMATIONS && HP_ANIMATION_TYPE
		? {
				'data-hp-trigger-selector': '',
				'data-hp-triggered-animation':
					HP_ANIMATION_TYPE,
				'data-hp-trigger-event':
					'viewport',
				'data-hp-triggered-played' : '0',
			}
		: {};

	if ( redirect && authenticated ) {
		return (
			<Btn onClick={handleClick} customClass={mergedClasses} {...animationData}>{t('home.prospectusButton', 'My Prospectus')}</Btn>
		)
	}
}
